export default __webpack_public_path__ + "static/media/close-up-man-is-heart-attack (1).f416466d.jpg";